import React from 'react';
import ReactDOM from 'react-dom/client';
import 'styles/global.css';
import { App, ConfigProvider } from 'antd';
import Apps from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ConfigProvider
    prefixCls="okvip"
    iconPrefixCls=""
    theme={{
      token: {
        colorPrimary: '#31a749',
        colorInfo: '#31a749',
        borderRadius: 4
      },
      components: {
        Button: {
          colorPrimary: '#31a749'
        },
        Layout: {
          headerHeight: 20
        }
      }
    }}
  >
    <App
      notification={{
        placement: 'topRight'
      }}
    >
      <Apps />
    </App>
  </ConfigProvider>
);
